module.exports = __webpack_public_path__ + "images/emoji/mountain_bicyclist.144080a5dcf0848a999d.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/mountain_bicyclist.png
// module id = KA9o
// module chunks = 2